import React, {useRef, useState} from 'react';
import Form, {ButtonItem, EmailRule, GroupItem, RequiredRule, SimpleItem} from "devextreme-react/form";
import {Layout} from "../../../../palette/Palette";
import {Button} from "devextreme-react/button";
import {Modal} from "react-bootstrap";

const buttonOptions = {
    text: 'Guardar',
    useSubmitBehavior: true,
    id: 'button-save',
    type: 'success',
    icon: 'far fa-check-circle'
};

function Invoice(props) {
    const {invoice, popupVisible, setPopupVisible, setInvoice} = props;


    const [submitButton] = useState(buttonOptions)

    const dxForm = useRef(null);

    const renderCancelButton = () => {
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => setPopupVisible(false)}/>
        )
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setInvoice(invoice)
        setPopupVisible(false)
    }

    return (
        <>
            <Modal show={popupVisible} dialogClassName="modal-12w" className="modal" animation={true} backdrop={true}>
                <Modal.Header>
                    <Modal.Title>Datos de facturación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Layout color={'transparent'}>
                        <div style={{height: 20}}/>
                        <form action="" onSubmit={handleSubmit}>
                            <Form
                                ref={dxForm}
                                formData={invoice}
                                readOnly={false}
                                showColonAfterLabel={true}
                                validationGroup="create-driver"
                            >
                                <GroupItem colCount={1}>
                                    <SimpleItem dataField="name" label={{text: 'Nombres'}}>
                                        <RequiredRule message="Ingrese los nombres"/>
                                    </SimpleItem>
                                    <SimpleItem dataField="RUC" label={{text: 'Cedula/RUC'}}>
                                        <RequiredRule message="Ingrese el numero de cedula/RUC"/>
                                    </SimpleItem>
                                    <SimpleItem dataField="contactNumber" label={{text: 'Telefono'}}>
                                        <RequiredRule message="Ingrese el numero de telefono"/>
                                    </SimpleItem>

                                    <SimpleItem dataField="email" label={{text: 'Correo electrónico'}}>
                                        <EmailRule message="Correo electrónico invalido"/>
                                        <RequiredRule message="Ingrese el correo electrónico de usuario"/>
                                    </SimpleItem>
                                    <SimpleItem dataField="address" label={{text: 'Dirección'}}>
                                        <RequiredRule message="Ingrese un dirección"/>
                                    </SimpleItem>
                                </GroupItem>
                                <GroupItem colCount={2}>
                                    <SimpleItem render={renderCancelButton}/>
                                    <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                                </GroupItem>
                            </Form>
                        </form>
                    </Layout>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default Invoice